import type { CameraSlot } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export interface CameraViewListItemResponse {
  id: string
  name: string
}

export interface CameraViewResponse {
  id: string
  name: string
  cols: number
  rows: number
  slots: CameraSlot[]
}

export interface CreateCameraViewPayload {
  name: string
  cols: number
  rows: number
  slots: CameraSlot[]
}

export interface UpdateCameraViewPayload extends Partial<CreateCameraViewPayload> {
  id: string
}

export const fetchCameraViews = async (): Promise<CameraViewListItemResponse[]> => {
  const response = await gozokiApiWithAuth.get<CameraViewListItemResponse[]>('/camera-views')
  return response.data
}

export const fetchCameraView = async (id: string): Promise<CameraViewResponse> => {
  const response = await gozokiApiWithAuth.get<CameraViewResponse>(`/camera-views/${id}`)
  return response.data
}

export const createCameraView = async (
  payload: CreateCameraViewPayload,
): Promise<CameraViewResponse> => {
  const response = await gozokiApiWithAuth.post<CameraViewResponse>('/camera-views', payload)
  return response.data
}

export const updateCameraView = async ({
  id,
  ...data
}: UpdateCameraViewPayload): Promise<CameraViewResponse> => {
  const response = await gozokiApiWithAuth.patch<CameraViewResponse>(`/camera-views/${id}`, data)
  return response.data
}

export const deleteCameraView = async (id: string): Promise<void> => {
  await gozokiApiWithAuth.delete(`/camera-views/${id}`)
}
